import { Translations } from './types'

/**
 * Fallback translations
 */
const DEFAULT_TRANSLATIONS: Translations = {
  ratings: 'Ratings',
  rateRecipe: 'Rate recipe',
  updateRating: 'Update rating',
  question: 'How did you like this recipe?',
  giveFeedback: 'Please provide feedback on how we could improve this recipe',
  rating1: 'Poor',
  rating2: 'Fair',
  rating3: 'Ok',
  rating4: 'Good',
  rating5: 'Great',
  submitRating: 'Submit Rating',
  submitLoading: 'Loading...',
  submitError:
    'Submission failed. Something went wrong. <br> Please try again later.',
  invalidRatingError:
    'Please try again! Give this recipe a star rating to submit.',
  submitThanksForRating: 'Thank you for rating this recipe!',
  notEnoughRatings: 'Not enough ratings'
}

/**
 * Use the default translations as fallback for missing key on the provided one.
 */
export const getTranslationsWithFallback = (
  translations?: Translations
): Translations => Object.assign({}, DEFAULT_TRANSLATIONS, translations)
